/**
 * Archetype mapping (role_definitions.code):
 * 1 — ADMIN (superadmin)
 * 2 — HR
 * 3 — VAM
 * 4 — PROVIDER (service provider; display name "Provider")
 */

export const LOGIN_ROLE_CODES = ["ADMIN", "HR", "VAM", "PROVIDER"];

/** Admin, HR, or VAM — can approve skill profiles and similar reviews. */
export function isStaffReviewerRole(role) {
  const R = String(role || "").toUpperCase();
  return R === "ADMIN" || R === "HR" || R === "VAM";
}

/** @returns {Set<string>|null} null means all paths allowed */
export function allowedPathSetForRole(role) {
  const R = String(role || "").toUpperCase();
  if (R === "ADMIN" || R === "HR") return null;

  const myAccount = ["/view-my-details"];

  if (R === "VAM") {
    return new Set([
      "/dashboard",
      "/client-module",
      "/onboard-module",
      "/view-onboard",
      "/view-scheduled",
      "/hr-requests",
      "/manage-employee",
      "/view-employee-details",
      ...myAccount,
    ]);
  }

  if (R === "PROVIDER") {
    return new Set([
      "/dashboard",
      "/onboard-module",
      "/view-onboard",
      "/attendance",
      "/hr-requests",
      ...myAccount,
    ]);
  }

  return new Set();
}

export function canAccessPath(path, role) {
  const norm = path.split("?")[0] || "";
  if (norm.startsWith("/employee-registration")) return true;

  const allowed = allowedPathSetForRole(role);
  if (allowed === null) return true;
  if (allowed.has(norm)) return true;
  if (norm.startsWith("/settings/")) return false;

  for (const p of allowed) {
    if (p !== "/" && norm.startsWith(p + "/")) return true;
  }
  return false;
}
